<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card v-if="visible">
      <v-card-title class="dialog__header">
        <span class="dialog__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="dialog__close-btn"
          :disabled="isLoading"
          icon
          @click="close"
        >
          <v-icon color="gray-6">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-html="$t(`${namespace}.text`)" class="dialog__body" />

      <v-divider />

      <v-card-actions class="dialog__footer">
        <v-spacer/>

        <a
          v-if="!isLoading"
          class="mr-4"
          @click.prevent="close()"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="primary"
          rounded
          depressed
          @click="handleSubmit"
        >
          {{ $t(`${namespace}.buttonLabel`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isValidObject } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'RemoveCompanyGroupDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    companyGroup: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyPage.removeCompanyGroupDialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isValidObject(val)
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    setLoadingValue (boolean) {
      this.isLoading = boolean
    },

    async handleSubmit () {
      this.setLoadingValue(true)

      try {
        const isValid = await this.$validator.validateAll()

        if (
          !this.isValidObject(this.companyGroup) ||
          (this.isValidObject(this.companyGroup) && !this.companyGroup.id)
        ) {
          throw new Error()
        }

        if (isValid) {
          await this.$apiService.companyGroup.delete(this.companyGroup.id)
          this.$emit('close', true)
          this.showAlert({
            type: 'success',
            message: this.$t(`${this.namespace}.success`)
          })
        }
      } catch (err) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.error`)
        })
      }

      this.setLoadingValue(false)
    }
  }
}
</script>
